import { useState } from "react";
import { api, ADMIN_STORAGE_KEY } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasscode = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async () => {
    if (f.next.trim().length < 8) return toast.error("The new passcode must be at least 8 characters.");
    if (f.next !== f.confirm) return toast.error("The new passcodes don't match.");
    setBusy(true);
    try {
      const { data } = await api.post("/admin/passcode", { current: f.current, new: f.next },
        { headers: { "X-Admin-Key": sessionStorage.getItem(ADMIN_STORAGE_KEY) } });
      const others = data.signed_out_devices;
      toast.success(`Passcode changed.${others ? ` ${others} other device${others === 1 ? "" : "s"} signed out.` : ""}`);
      setF(EMPTY);
      setOpen(false);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not change the passcode.");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" data-testid="change-passcode-open" onClick={() => setOpen(true)}
        className="ml-auto inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-600 border border-border text-ink/70 hover:border-gold">
        <KeyRound className="w-4 h-4" /> Change passcode
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setF(EMPTY); }}>
        <DialogContent data-testid="change-passcode-dialog" className="bg-parchment max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-ink">Change admin passcode</DialogTitle>
            <DialogDescription>All other signed-in devices will need the new passcode. You'll get an email at info@brothersimmanuel.ca.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2.5">
            <Input data-testid="change-passcode-current" type="password" placeholder="Current passcode" value={f.current} onChange={set("current")} autoComplete="current-password" />
            <Input data-testid="change-passcode-new" type="password" placeholder="New passcode (8+ characters)" value={f.next} onChange={set("next")} autoComplete="new-password" />
            <Input data-testid="change-passcode-confirm" type="password" placeholder="Type the new passcode again" value={f.confirm} onChange={set("confirm")} autoComplete="new-password"
              onKeyDown={(e) => e.key === "Enter" && submit()} />
            <Button data-testid="change-passcode-submit" disabled={busy} onClick={submit}
              className="w-full h-11 rounded-full bg-gold text-ink hover:bg-ink hover:text-parchment font-700">
              {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />} Change passcode
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
